import { useMutation, useQuery } from '@apollo/client/react';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { CandidateDocument } from '@pflegia/data-access/candidate.generated';
import { CandidateProfileState } from '@pflegia/types/common/enums';
import { useAuth } from '@pflegia/ui/contexts/auth.context';
import { useGoogleRecaptchaV3 } from '@pflegia/ui/hooks/use-google-recaptcha-v3';

import { LOGOUT, MAINTENANCE, SETTINGS } from '@shared/application/constants';
import { CHANGE_CANDIDATE_PROFILE_STATE } from '@shared/graphql/mutations';

const useHandlePausedAccount = () => {
  const router = useRouter();
  const authenticated = useAuth();
  const { setRecaptchaToken } = useGoogleRecaptchaV3();
  const hasTriggeredRef = useRef(false);
  const [changeCandidateProfileState] = useMutation(CHANGE_CANDIDATE_PROFILE_STATE, {
    onCompleted: async () => {
      if (router.query.goto) {
        await router.push(router.query.goto as string);
      }
    },
  });

  const skip = !authenticated || [LOGOUT, MAINTENANCE, SETTINGS].some(path => router.pathname.includes(path));
  const { data } = useQuery(CandidateDocument, {
    nextFetchPolicy: 'network-only',
    skip,
  });

  useEffect(() => {
    if (hasTriggeredRef.current || skip || data?.candidate.candidateProfileState !== CandidateProfileState.Paused) return;

    hasTriggeredRef.current = true;
    setRecaptchaToken('changeCandidateProfileState_active').then(() => {
      changeCandidateProfileState({ variables: { state: CandidateProfileState.Active } });
    });
  }, [changeCandidateProfileState, data, setRecaptchaToken, skip]);
};

export default useHandlePausedAccount;
